import { render, staticRenderFns } from "./LessonResourcesByCategories.vue?vue&type=template&id=695d272e&scoped=true&"
import script from "./LessonResourcesByCategories.vue?vue&type=script&lang=js&"
export * from "./LessonResourcesByCategories.vue?vue&type=script&lang=js&"
import style0 from "./LessonResourcesByCategories.vue?vue&type=style&index=0&id=695d272e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695d272e",
  null
  
)

export default component.exports